<button
  (click)="openMenu()"
  class="menu-btn">
  <img src="../../../../../assets/img/context-menu.svg" alt="Context-menu" class="menu-btn__icon">
</button>
<ul
  [class.active]="isOpenMenu"
  class="menu-list">
  <li
    (click)="openModalEditRole()"
    class="menu-list__item">
    {{'ROLE_PAGE.EDIT' | translate}}
  </li>
  <li
    (click)="openModalDeleteRole()"
    class="menu-list__item">
    {{'ROLE_PAGE.DELETE' | translate}}
  </li>
</ul>
